import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "table table-hover align-middle mt-4" }
const _hoisted_2 = { class: "border-dark border-bottom pb-2" }
const _hoisted_3 = { class: "border-dark border-bottom" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("th", null, " ", -1)
const _hoisted_5 = { key: 1 }
const _hoisted_6 = {
  colspan: 5,
  class: "fw-bold small text-uppercase text-muted"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_title = _resolveComponent("base-title")!
  const _component_AlertError2 = _resolveComponent("AlertError2")!
  const _component_base_placeholder_table = _resolveComponent("base-placeholder-table")!
  const _component_ContentPreviewOverviewItem = _resolveComponent("ContentPreviewOverviewItem")!
  const _component_base_container = _resolveComponent("base-container")!

  return (_openBlock(), _createBlock(_component_base_container, { "container-fluid": "" }, {
    default: _withCtx(() => [
      _createVNode(_component_base_title, {
        title: _ctx.$t('fullPreviews'),
        mb: 3,
        "show-refresh-button": "",
        onRefresh: _ctx.reloadContent
      }, null, 8, ["title", "onRefresh"]),
      _createVNode(_component_AlertError2, {
        error: _ctx.pageUI.getError()
      }, null, 8, ["error"]),
      _createElementVNode("table", _hoisted_1, [
        _createElementVNode("thead", _hoisted_2, [
          _createElementVNode("tr", _hoisted_3, [
            _createElementVNode("th", null, _toDisplayString(_ctx.$t('name')), 1),
            _createElementVNode("th", null, _toDisplayString(_ctx.$t('previewKey')), 1),
            _createElementVNode("th", null, _toDisplayString(_ctx.$t('status')), 1),
            _createElementVNode("th", null, _toDisplayString(_ctx.$t('period')), 1),
            _hoisted_4
          ])
        ]),
        _createElementVNode("tbody", null, [
          (!_ctx.pageUI.isReady())
            ? (_openBlock(), _createBlock(_component_base_placeholder_table, {
                key: 0,
                "n-cols": 5
              }))
            : (!_ctx.hasContentPreviews)
              ? (_openBlock(), _createElementBlock("tr", _hoisted_5, [
                  _createElementVNode("td", _hoisted_6, _toDisplayString(_ctx.$t('noContentFound')), 1)
                ]))
              : (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(_ctx.contentPreviews, (contentPreview) => {
                  return (_openBlock(), _createBlock(_component_ContentPreviewOverviewItem, {
                    key: contentPreview.id,
                    "content-preview": contentPreview
                  }, null, 8, ["content-preview"]))
                }), 128))
        ])
      ])
    ]),
    _: 1
  }))
}